import { z } from 'zod';

import { AiClassificationLabelSchema } from './ai-classification';
import { AiImageSchema } from './ai-image';
import { AiRequestBaseSchema } from './ai-request';

/**
 * Label-and-confidence classification of an **image** — the `classifyImage`
 * half of the provider interface, served by the `ai-image` capability (P27b1).
 *
 * The same grammar as `classify`, over an image instead of a text: the labels
 * define the categories, the adapter constrains the vendor to a JSON schema
 * derived from them, and the answer is an `AiClassificationResult` — one
 * result shape for every classification the platform makes, so a consumer
 * reads a score the same way whichever input produced it.
 */
export const AiImageClassificationRequestSchema = AiRequestBaseSchema.extend({
  /** Optional extra framing (what the reviewer is looking for, locale notes). */
  system: z.string().min(1).max(100_000).optional(),
  image: AiImageSchema,
  labels: z.array(AiClassificationLabelSchema).min(1).max(50),
  /** On for anything a human later reviews — an advisory with no rationale cannot be checked. */
  includeReason: z.boolean().optional(),
  maxOutputTokens: z.number().int().min(1).max(8_000),
}).strict();

export type AiImageClassificationRequest = z.infer<typeof AiImageClassificationRequestSchema>;
